module.exports = __webpack_public_path__ + "img/public/SiteIcons/goSiteIcon.svg?8e63050b";